import React from 'react';
import Tooltip from './common/Tooltip';
import { formatRelativeTime } from '../utils/dateUtils';

const PriceUpdateInfo = ({ timestamp }) => {
  if (!timestamp) return null;
  const description = `Price updated ${formatRelativeTime(timestamp)}`;

  return (
    <Tooltip title={description} trigger="mouseenter focus click" arrow={true} position="top" theme="dark">
      <button type="button" aria-label={description} className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-gray-400 hover:text-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500 dark:text-gray-500 dark:hover:text-gray-300">
        <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-4 w-4">
          <circle cx="10" cy="10" r="7.5" />
          <path strokeLinecap="round" d="M10 9v4m0-6v.1" />
        </svg>
      </button>
    </Tooltip>
  );
};

export default PriceUpdateInfo;
